import { clsx } from "clsx";
import React from "react";
import classes from "./Heading.module.scss";
import { HeadingProps } from "./HeadingProps";

export const Heading: React.FC<HeadingProps> = (props: HeadingProps) => {
  const {
    children,
    as: Component = "h2",
    size,
    className,
    gutterBottom,
    align,
    ...htmlProps
  } = props;

  const classNames = clsx(
    classes.heading,
    classes[Component],
    align && classes[`align-${align}`],
    size && classes[`text-${size}`],
    gutterBottom && classes.gutter,
    className,
  );

  return (
    <Component className={classNames} {...htmlProps}>
      {children}
    </Component>
  );
};
